import { useMutation, UseMutationResult, useQueryClient } from 'react-query'

import { HomeService } from 'features/projects/service'

export const useDeleteProject = (
  service: HomeService,
): UseMutationResult<unknown, unknown, string> => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (uuid: string) => service.removeProject(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries(['home', 'projects'])
    },
  })
}
